export const GET_QUESTION_ENDPOINT = "questions/";
